var map = {
	"./admitAction": 536,
	"./banAction": 3044,
	"./canvasTextAction": 7166,
	"./chatAction": 3551,
	"./faceApiAction": 30,
	"./muteUserMicAction": 2404,
	"./terminateAction": 7970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5346;